import { ReactNode } from "react";
import { Header } from "@/shared/layout/authenticatedHeader/Header";
// import { Footer } from "@/shared/layout/authenticatedHeader/Footer";
import styles from "./AuthenticatedLayout.module.css";

interface AuthenticatedLayoutProps {
  children: ReactNode;
}

/**
 * Layout for authenticated routes
 * Includes header, sidebar, and footer
 */
export const AuthenticatedLayout = ({ children }: AuthenticatedLayoutProps) => {
  return (
    <div className={styles.authenticatedLayout}>
      <Header />
      <div className={styles.layoutContent}>
        {/* <Sidebar /> */}
        <main className={styles.mainContent}>{children}</main>
      </div>
      {/* <Footer /> */}
    </div>
  );
};
